var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.27777 0.972656C1.61665 0.972656 1.94166 1.10728 2.18128 1.34691C2.42091 1.58653 2.55553 1.91154 2.55553 2.25042V3.37486C3.90997 2.81264 5.74995 2.25042 7.6666 2.25042C11.4999 2.25042 11.4999 4.80596 14.0554 4.80596C17.8887 4.80596 19.1665 2.25042 19.1665 2.25042V12.4726C19.1665 12.4726 17.8887 15.0281 14.0554 15.0281C10.2221 15.0281 10.2221 12.4726 7.6666 12.4726C3.8333 12.4726 2.55553 15.0281 2.55553 15.0281V23.9725H0V2.25042C0 1.91154 0.134622 1.58653 0.37425 1.34691C0.613877 1.10728 0.938882 0.972656 1.27777 0.972656ZM2.55553 6.40317V11.8337C2.55553 11.8337 5.11107 9.91702 7.6666 9.91702C10.2221 9.91702 11.4999 12.4726 14.0554 12.4726C16.611 12.4726 16.611 11.1948 16.611 11.1948V6.72261C16.611 6.72261 15.3332 7.36149 14.0554 7.36149C11.4999 7.36149 10.2221 4.80596 7.6666 4.80596C5.11107 4.80596 2.55553 6.40317 2.55553 6.40317Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.5bffd1b8.svg";
export { ForwardRef as ReactComponent };